import React from "react";
import { Layers } from "lucide-react";

// Standardized, uncropped product image stage. A fixed aspect-ratio box (same across breakpoints)
// with the full garment fitted inside (object-contain, centered, padded) — never object-cover.
const RATIOS = { portrait: "aspect-[4/5]", landscape: "aspect-[4/3]", square: "aspect-square" };

export function ImageStage({ src, alt, ratio = "portrait", pad = "p-3", className = "", testid, children }) {
  return (
    <div data-testid={testid} className={`relative w-full ${RATIOS[ratio] || RATIOS.portrait} bg-blush overflow-hidden ${className}`}>
      {src ? (
        <img src={src} alt={alt || "Product image"} loading="lazy" className={`absolute inset-0 w-full h-full object-contain object-center ${pad}`} />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-brand/40" aria-hidden="true"><Layers size={30} /></div>
      )}
      {children}
    </div>
  );
}

export default ImageStage;
